import { render, staticRenderFns } from "./InOrd.vue?vue&type=template&id=e589fea4&scoped=true"
import script from "./InOrd.vue?vue&type=script&lang=js"
export * from "./InOrd.vue?vue&type=script&lang=js"
import style0 from "./InOrd.vue?vue&type=style&index=0&id=e589fea4&lang=scss&scoped=true"
import style1 from "./InOrd.vue?vue&type=style&index=1&id=e589fea4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e589fea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e589fea4')) {
      api.createRecord('e589fea4', component.options)
    } else {
      api.reload('e589fea4', component.options)
    }
    module.hot.accept("./InOrd.vue?vue&type=template&id=e589fea4&scoped=true", function () {
      api.rerender('e589fea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/InOrd.vue"
export default component.exports